import { useQuery } from "react-query"
import { AxiosError } from "axios"
import { IConsultantModel, IHttpErrorResponseModel } from "@common-models/*"
import { toast } from "react-toastify"
import MySimpleSpinner from "@common-utils/MySimpleSpinner"
import MyAlert from "@common-utils/MyAlert"
import React, { useState } from "react"
import { useConsultant } from "../../modules/business/consultants/core/useConsultant"
import { getDocsToSendEmbaucheDocuments } from "../../modules/recrutement/demandesEmbauche/details/_documents/core/_requests"
import MyGoogleDriveFileViewerInModal from "../MyDocumentViewer/MyGoogleDriveFileViewerInModal"

const EnvoyerOuIgnorerEnvoiDocEmbauche = ({
     consultant,
     onQueryFetched = () => {},
     onSuccessIgnorerEnvoiDocCallback = () => {},
     onSuccessEnvoyerDocCallback = () => {},
     isIgnorerButtonHidden = false,
     isEnvoyerButtonHidden = false,
     hasCheckboxes = true,
}: IPropsModel) => {
     const { documentsEmbaucheEnvoyer, documentsEmbaucheIgnorerEnvoi } = useConsultant()

     const [documentInModal, setdocumentInModal] = useState<{
          driveID: string
          driveMime: string
          modalTitle: string
          isLoading: boolean
     }>()

     const [checkedDocuments, setCheckedDocuments] = useState<
          {
               type: "CONTRAT_TRAVAIL" | "ODM"
               checked: boolean
          }[]
     >([
          { type: "CONTRAT_TRAVAIL", checked: true },
          { type: "ODM", checked: true },
     ])

     const getDocsEmbaucheQuery = useQuery<{ titre: string; googleDriveId: string; googleMimeType: string; type: "CONTRAT_TRAVAIL" | "ODM" | null }[], AxiosError>(
          "REACT_QUERY_KEY_GET_DOCS_EMBAUCHE_CONSULTANT",
          async () => {
               return getDocsToSendEmbaucheDocuments(consultant.id!)
                    .then(r => {
                         onQueryFetched()
                         return r.data
                    })
                    .catch((e: AxiosError) => {
                         const error: IHttpErrorResponseModel = e.response?.data

                         toast.error(error?.detail, { autoClose: false })

                         throw e
                    })
          }
     )

     function handleIgnorerEnvoi() {
          const success = () => onSuccessIgnorerEnvoiDocCallback()
          documentsEmbaucheIgnorerEnvoi(
               consultant,
               () => {},
               () => success()
          )
     }

     function handleEnvoyerDocs() {
          const success = () => onSuccessEnvoyerDocCallback()
          documentsEmbaucheEnvoyer(
               consultant,
               checkedDocuments.find(c => c.type === "CONTRAT_TRAVAIL")?.checked || false,
               checkedDocuments.find(c => c.type === "ODM")?.checked || false,
               () => {},
               () => success()
          )
     }

     return (
          <>
               {getDocsEmbaucheQuery.isFetching && (
                    <div className={"text-center p-5"}>
                         <MySimpleSpinner size={"xl"} />
                    </div>
               )}

               {!getDocsEmbaucheQuery.isFetching && getDocsEmbaucheQuery.isError && (
                    <MyAlert type={"danger"} classNames={"mb-4"}>
                         <>
                              <span className={"me-2"}>{getDocsEmbaucheQuery.error?.response?.data?.detail}</span>
                              <button className={"btn btn-sm btn-danger"} onClick={() => getDocsEmbaucheQuery.refetch()}>
                                   Recharger
                              </button>
                         </>
                    </MyAlert>
               )}

               {!getDocsEmbaucheQuery.isFetching && !getDocsEmbaucheQuery.isError && getDocsEmbaucheQuery.data && (
                    <>
                         <>{getDocsEmbaucheQuery.data.length === 0 && <div className={"p-5"}>Aucun documents à envoyer</div>}</>
                         <>
                              {getDocsEmbaucheQuery.data.length > 0 && (
                                   <>
                                        <div className={"d-flex gap-5 text-center justify-content-center"}>
                                             {!isIgnorerButtonHidden && (
                                                  <button className={"btn btn-danger btn-sm"} onClick={handleIgnorerEnvoi}>
                                                       Ignorer
                                                  </button>
                                             )}
                                             {!isEnvoyerButtonHidden && (
                                                  <button className={"btn btn-primary btn-sm"} onClick={handleEnvoyerDocs}>
                                                       Envoyer
                                                  </button>
                                             )}
                                        </div>

                                        {(!isEnvoyerButtonHidden || !isIgnorerButtonHidden) && <div className={"separator separator-dashed my-5"} />}

                                        <ul className="list-group">
                                             {getDocsEmbaucheQuery.data.map(item => (
                                                  <li
                                                       className="list-group-item bg-hover-light d-flex justify-content-between text-hover-primary"
                                                       onClick={() =>
                                                            setdocumentInModal({
                                                                 modalTitle: `${item.titre}`,
                                                                 driveID: item.googleDriveId as string,
                                                                 driveMime: item.googleMimeType as string,
                                                                 isLoading: true,
                                                            })
                                                       }
                                                       key={item.googleDriveId}
                                                  >
                                                       <span>
                                                            <i className="fas fa-file-image me-2 text-dark" />
                                                            <span className={"fw-bold"}>{item.titre}</span>
                                                       </span>
                                                       {hasCheckboxes && (
                                                            <span className="form-check form-check-custom">
                                                                 <input
                                                                      type={"checkbox"}
                                                                      checked={item.type === null || checkedDocuments.find(c => c.type === item.type)?.checked || false}
                                                                      onChange={() => {
                                                                           setCheckedDocuments(prev =>
                                                                                prev.map(doc => (doc.type === item.type ? { ...doc, checked: !doc.checked } : doc))
                                                                           )
                                                                      }}
                                                                      onClick={e => e.stopPropagation()}
                                                                      readOnly={item.type === null}
                                                                      disabled={item.type === null}
                                                                      className={"form-check-input border-secondary cursor-pointer h-25px w-25px me-2"}
                                                                 />
                                                                 <span className={"text-primary"}>
                                                                      {item.type === null ? (
                                                                           <span className={"text-primary"}>Inclus</span>
                                                                      ) : checkedDocuments.find(c => c.type === item.type)?.checked ? (
                                                                           <span className={"text-primary"}>Inclus</span>
                                                                      ) : (
                                                                           <span className={"text-warning"}>Exclu</span>
                                                                      )}
                                                                 </span>
                                                            </span>
                                                       )}
                                                  </li>
                                             ))}
                                        </ul>
                                   </>
                              )}
                         </>
                    </>
               )}

               {documentInModal && (
                    <MyGoogleDriveFileViewerInModal
                         googleDriveID={documentInModal.driveID as string}
                         googleDriveMimetype={documentInModal.driveMime as string}
                         modalTitle={<span>{documentInModal.modalTitle}</span>}
                         handleCloseModal={() => setdocumentInModal(undefined)}
                         modalSize={"xl"}
                    />
               )}
          </>
     )
}

interface IPropsModel {
     consultant: IConsultantModel
     onQueryFetched?: () => void
     onSuccessIgnorerEnvoiDocCallback?: () => void
     onSuccessEnvoyerDocCallback?: () => void
     isIgnorerButtonHidden?: boolean
     isEnvoyerButtonHidden?: boolean
     hasCheckboxes?: boolean
}

export default EnvoyerOuIgnorerEnvoiDocEmbauche
